module.exports = "/_next/static/images/Ecaterina_Sharapova-ffbcea063ba1b21cfe2cf82a005e5374.webp";